import Header from "../../components/feature/Header";
import Footer from "../../components/feature/Footer";
import { Link } from "react-router-dom";
import { mockServices } from "../../mocks/services";

export default function Services() {
  return (
    <div className="bg-arch-cream font-sans">
      <Header />
      <main>
        {/* Header */}
        <section className="pt-36 pb-16 px-8 lg:px-14 bg-white border-b border-arch-border">
          <p className="text-arch-light text-xs tracking-[0.2em] uppercase mb-4">What We Offer</p>
          <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6">
            <h1 className="font-serif text-5xl lg:text-6xl text-arch-charcoal font-light leading-tight max-w-xl">
              Architectural Services
            </h1>
            <p className="text-arch-gray text-sm font-light leading-relaxed max-w-sm">
              Studio 1323 offers comprehensive architectural services across residential, multi-family, and hospitality sectors in Santa Monica and Los Angeles.
            </p>
          </div>
        </section>

        {/* Services list */}
        <section className="py-20 px-8 lg:px-14 bg-arch-cream">
          <div className="space-y-16">
            {mockServices.map((service, i) => (
              <div key={service.id} className={`grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center ${i % 2 !== 0 ? "lg:flex-row-reverse" : ""}`}>
                <div className={`${i % 2 !== 0 ? "lg:order-2" : ""}`}>
                  <div className="w-full h-72 lg:h-80 overflow-hidden rounded-lg">
                    <img src={service.image} alt={service.title + " Studio 1323"} className="w-full h-full object-cover object-top" />
                  </div>
                </div>
                <div className={`${i % 2 !== 0 ? "lg:order-1" : ""}`}>
                  <p className="text-arch-light text-xs tracking-[0.2em] uppercase mb-2">{service.tagline}</p>
                  <h2 className="font-serif text-3xl lg:text-4xl text-arch-charcoal font-light mb-4">{service.title}</h2>
                  <p className="text-arch-gray text-sm font-light leading-relaxed mb-6">{service.description}</p>
                  <ul className="space-y-2 mb-8">
                    {service.highlights.map((h) => (
                      <li key={h} className="flex items-center gap-3 text-sm text-arch-gray font-light">
                        <i className="ri-checkbox-circle-line text-arch-charcoal" />
                        {h}
                      </li>
                    ))}
                  </ul>
                  <Link
                    to={service.href}
                    className="inline-flex items-center gap-2 border border-arch-charcoal text-arch-charcoal px-6 py-3 text-xs tracking-[0.15em] uppercase font-medium hover:bg-arch-charcoal hover:text-white transition-all rounded-md cursor-pointer whitespace-nowrap"
                  >
                    Learn More <i className="ri-arrow-right-line" />
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* CTA */}
        <section className="py-16 px-8 lg:px-14 bg-[#111111] flex flex-col lg:flex-row items-start lg:items-center justify-between gap-8">
          <div>
            <h2 className="font-serif text-3xl text-white font-light">Not sure what service you need?</h2>
            <p className="text-white/50 text-sm font-light mt-2">Let&apos;s talk through your project — we&apos;ll help identify the right approach.</p>
          </div>
          <Link
            to="/contact"
            className="inline-flex items-center gap-2 bg-white text-arch-charcoal px-7 py-3.5 text-xs tracking-[0.15em] uppercase font-semibold hover:bg-white/90 transition-all rounded-md cursor-pointer whitespace-nowrap"
          >
            Request Consultation <i className="ri-arrow-right-line" />
          </Link>
        </section>
      </main>
      <Footer />
    </div>
  );
}
